import { render, staticRenderFns } from "./PaxInformation.vue?vue&type=template&id=4369d294&scoped=true&"
import script from "./PaxInformation.vue?vue&type=script&lang=js&"
export * from "./PaxInformation.vue?vue&type=script&lang=js&"
import style0 from "./PaxInformation.vue?vue&type=style&index=0&id=4369d294&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4369d294",
  null
  
)

export default component.exports